module.exports = __webpack_public_path__ + "images/rating-star-39ca27fe.svg";